// Guru Parampara - complete lineage of Sri Sode Vadiraja Matha
// Content sourced from the official "Pontiffs - Parampara Explorer" document.

export const PARAMPARA = [
  {
    name: "Sri Vishnutirtha",
    period: "13th century",
    role: "Founder - direct disciple of Sri Madhvacharya",
    note:
      "Younger brother and direct disciple of Jagadguru Sri Madhvacharya. Renowned for his Vairagya and devoted service. After his parents' passing he took Sanyasashrama from Madhva and undertook rigorous austerity on Harishchandra mountain, developing extraordinary mystic powers and realising the Indwelling Lord. He authored Samnyasapaddhati, Shravanadwadashinirnaya, Vishnupanchakanirnaya and Panchasamskarasangraha. His two pupils Vyasatirtha and Aniruddhatirtha established Sri Sode Vadiraja Matha and Subrahmanya Matha respectively. Madhva blessed him with the icons of Bhuvaraha and Abhedyasamputa. He is believed to be still performing penance at the Kumara mountain, awaiting Madhva's command to re-establish Dvaita Siddhanta. He is one of the Rujugods and specially adored Lord Hayagriva.",
  },
  {
    name: "Sri Vyaasatirtha",
    period: "Vrindavana-pravesha 1327 A.D.",
    role: "Peethadhipati",
    note:
      "Direct disciple of Sri Vishnutirtha. An undaunted scholar, great poet and worthy of the blessings of both Madhva and Vishnutirtha. He combined intellectual skill with poetic talent, honoured the icons of the hierarchy and contributed to Madhva's intellectual and scholastic pursuits.",
  },
  {
    name: "Sri Vedyatirtha",
    period: "Vrindavana-pravesha 1336 A.D. - 9 years on the peetha",
    role: "Peethadhipati",
    note:
      "Received Samnyasashrama from Vyasatirtha. A great scholar who dedicated himself to learning and teaching Shastras, performed grand worship, undertook pilgrimages and uplifted souls through devoted advice.",
  },
  {
    name: "Sri Vedagarbhatirtha",
    period: "Vrindavana-pravesha 1346 A.D. - 10 years on the peetha",
    role: "Peethadhipati",
    note:
      "Known for understanding the secrecy of Mantras which brought him Siddhi. He used this power to relieve the suffering of many and gained fame by dedicated practice of prescribed norms.",
  },
  {
    name: "Sri Vareshatirtha",
    period: "Vrindavana-pravesha 1354 A.D. - 8 years on the peetha",
    role: "Peethadhipati",
    note:
      "Devoted student of Madhva's 'Sarvamula' works with a commanding grasp of many texts. He delivered fluent lectures, learned works by heart and successfully propagated the Siddhanta while touring widely.",
  },
  {
    name: "Sri Vamanatirtha",
    period: "Vrindavana-pravesha 1362 A.D. - 8 years on the peetha",
    role: "Peethadhipati",
    note:
      "After Samnyasashrama he undertook pilgrimages to holy centres. His special love for the Bhagavata Purana led him to give regular discourses, captivating devotees with devotion-inducing recitations. He nominated his successor before reaching old age.",
  },
  {
    name: "Sri Vasudevatirtha",
    period: "Vrindavana-pravesha 1369 A.D. - 7 years on the peetha",
    role: "Peethadhipati",
    note:
      "Continued the tradition of worship and observances. Taught and lectured on Madhva's Brahmasutrabhashya - a text he had memorised entirely - considering it a living replica of Madhva's presence. Spent most of his life at Udupi.",
  },
  {
    name: "Sri Vedavyasatirtha",
    period: "Vrindavana-pravesha 1377 A.D. - 8 years on the peetha",
    role: "Peethadhipati",
    note:
      "A matchless scholar and formidable debater, always at the forefront of intellectual exchanges. He could spontaneously quote from opponents' works to refute their tenets. Blessed by Sri Hari-Vayu-Guru, he excelled in debate and discourse with mastery over Shankarabhashya and other works.",
  },
  {
    name: "Sri Varahatirtha",
    period: "Vrindavana-pravesha 1386 A.D. - 9 years on the peetha",
    role: "Peethadhipati",
    note:
      "Direct disciple of Vedavyasatirtha, deeply engaged in Japa and Tapa. Possessing profound Yogic power he preferred deep meditation in solitary places and blessed faithful devotees with the fruits of his penance. Nominated his successor in middle age.",
  },
  {
    name: "Sri Vedatmatirtha",
    period: "Vrindavana-pravesha 1398 A.D. - 12 years on the peetha",
    role: "Peethadhipati",
    note:
      "Well-versed in the Vedas and Vedangas and a great poet. His extant 'Kavikarnamrutam' - a commentary on Trivikrama Panditacharya's Vayustuti - showcases his poetic talent and grammatical skill. He may also have composed a commentary on Madhva's Nakhastuti.",
  },
  {
    name: "Sri Vishwavandyatirtha - I",
    period: "Vrindavana-pravesha 1422 A.D. - 24 years on the peetha",
    role: "Peethadhipati",
    note:
      "Multi-faceted, highly learned and experienced in both Shastric fields and worldly affairs. Master of all lores and arts and a formidable debater who often stunned opponents with immediate and relevant replies.",
  },
  {
    name: "Sri Ratnagarbhatirtha",
    period: "Entombed prior to 1422 A.D.",
    role: "Peethadhipati",
    note:
      "Ordained by Vishwavandyatirtha-I. A matchless scholar in Veda, Vedanga and Vedanta and an inestimable Yogin. Performed severe penance at Narala developing extraordinary Yogic powers including levitation. Once saved the king of the Chowt family through divine intervention - Lord Varaha destroying the enemy force and ensuring water supply to the region - for which the Matha was gifted land.",
  },
  {
    name: "Sri Vedangatirtha",
    period: "Vrindavana-pravesha 1441 A.D.",
    role: "Peethadhipati",
    note:
      "A great author preceding Vadirajatirtha in this lineage. Received Samnyasashrama from Vishwavandyatirtha and mastered Veda-Vedanga-Vedanta. Diligently followed observances and authored several commentaries, glosses and independent works. His Vrindavana is on the bank of the Soma river in Bilagi.",
  },
  {
    name: "Sri Vidyapatitirtha",
    period: "Vrindavana-pravesha 1449 A.D. - 8 years on the peetha",
    role: "Peethadhipati",
    note:
      "Ardent disciple of Vedangatirtha, well-known among the pious and virtuous. Spent much of his life at Udupi, reciting holy texts even while walking.",
  },
  {
    name: "Sri Vishwavandyatirtha - II",
    period: "Vrindavana-pravesha 1458 A.D. - 9 years on the peetha",
    role: "Peethadhipati",
    note:
      "Successor to Vidyapatitirtha; possessed unique Yogic powers of Anima and Mahima. Merciful and compassionate, he was concerned with the welfare of honest people and often prescribed remedial measures. Once paralysed his opponents' schemes during a Paryaya with his mystic power.",
  },
  {
    name: "Sri Vishwatirtha",
    period: "Vrindavana-pravesha 1466 A.D. - 8 years on the peetha",
    role: "Peethadhipati",
    note:
      "Flawlessly implemented the prescribed norms of the Parampara and dedicated his life to propagating the doctrines of Dvaita Siddhanta.",
  },
  {
    name: "Sri Vitthalatirtha",
    period: "Vrindavana-pravesha 1473 A.D. - 7 years on the peetha",
    role: "Peethadhipati",
    note:
      "Frequently stayed at Madhyavatamatha and worshipped Lord Vedavyasa with pure devotion, receiving his merciful blessings.",
  },
  {
    name: "Sri Varadarajatirtha - I",
    period: "Entombed 1481 A.D. at Kumbhasi - 8 years on the peetha",
    role: "Peethadhipati",
    note:
      "Eighteenth pontiff in the lineage of Sri Vishnutirtha. Undertook numerous pilgrimages and renovated the Kumbhasimatha. Academic master of the Bhagavad Gita who held scholarly debates. Once blessed a mute person with the power of oration and saved a Brahmin from cancer through mystic power.",
  },
  {
    name: "Sri Vagishatirtha",
    period: "Departed Chaitra Bahula Dvitiya 1518 A.D. - 37 years on the peetha",
    role: "Ashramaguru of Sri Vadirajatirtha",
    note:
      "Nineteenth pontiff and celebrated Ashramaguru of Sri Vadirajatirtha. A saint-scholar with intuitive knowledge of the Lord. Through his mystic vision he foresaw and prepared for the incarnation of Vadirajatirtha, whom he ordained and named. Possessed refined knowledge of past, present and future and redressed devotees' sufferings with blessed Mantrakshata.",
  },
  {
    name: "Sri Vadirajatirtharu",
    period: "1481 A.D. - the luminary of Sode Matha",
    role: "The luminous crest jewel of the lineage",
    note:
      "Born on Magha Shukla Dwadashi of Sharvari Samvatsara. Birth name Varaha (blessed by Lord Varaha). Ordained Samnyasashrama at age 7 by Vagishatirtha and named Vadirajatirtha for his proficiency in delivering the import of lores and prowess as a debater. Studied under Vidyanidhi and Vagishatirtha. Composed the Sanskrit 'Tirthaprabandha' during his pan-India tour and, at Lord Vedavyasa's direction from Urdhvabadari, authored 'Lakshalankara' - a commentary on the Mahabharata. Brought back the Vyasamushti and enshrined it at Madhyavatamatha, and received the Hayagriva icon from a Daivajna brahmin whom he initiated with Vaishnavadiksha.",
  },
  {
    name: "Sri Vedavedyatirtha",
    period: "1530 - 1616 (76 years of Samnyasa, 15 on the peetha)",
    role: "Direct disciple and successor of Sri Vadiraja",
    note:
      "Ordained by Vadiraja in 1540. Performed two biennial Paryayas (1596-97 and during Venkatappanaik's reign). Introduced the system of Samapuja (worshipping Vadiraja along with god Vayu and his incarnations) and the proclamation of Paraku after evening worship. He is the Rushi for the Vadiraja Mantra and possesses the Siddhi power of the Vadiraja mantra. He is known as one of the Ruju gods (Gavya). Authored a commentary on Tantrasara, yet unfound.",
  },
  {
    name: "Sri Vidyanidhitirtha",
    period: "Entombed 1598 A.D. - 13 years of Samnyasashrama",
    role: "Peethadhipati",
    note:
      "Took Samnyasashrama from Vedavedyatirtha in 1585. Studied under Vadiraja and served as right hand to Vedavedya, assisting in his first Paryaya. A good orator who - foreseeing his short lifespan on Vadiraja's advice - went on pilgrimage. Entombed at Kumbhasimatha. He is the only pontiff in this lineage who did not perform a Paryaya at Udupi. Nominated Sri Vedanidhitirtha as his successor.",
  },
  {
    name: "Sri Vedanidhitirtha",
    period: "Entombed 1648 A.D. - 55 years of Samnyasa, 32 on the peetha (Paryayas 1628-29 & 1644-45)",
    role: "Peethadhipati",
    note:
      "Prashishya of Vadiraja; took Samnyasashrama from Vidyanidhitirtha in 1593. Served Vadiraja during his fifth Paryaya at Sode and later witnessed Vadiraja's Vrindavanapravesha. Documented the sacred 'Svapnavrindavanakhyana' through his pupil Ramachandracharya and compiled 'Anuvrindavanakhyana'. Introduced daily worship of a holy inscription and installed a sacred stone pillar bearing Vadiraja's figure. Controlled a king cobra at Madhyavatamatha, instructing it to be present at Sode.",
  },
  {
    name: "Sri Varadarajatirtha - II",
    period: "Vrindavana-pravesha 1673 A.D. - 25 years on the peetha (Paryaya 1660-61)",
    role: "Peethadhipati",
    note:
      "Ordained by Vedanidhitirtha; received Vadiraja's blessings through devoted service. Spent considerable time at Tirthahalli Matha regularly engaging in Patha-Pravachana.",
  },
  {
    name: "Sri Vishwadhirajatirtha",
    period: "Entombed 1688 A.D. at Sode - 15 years on the peetha (Paryaya 1676-77)",
    role: "Peethadhipati",
    note:
      "Preferred to stay at Sode offering devoted service to Vadiraja. Regularly engaged in Patha-Pravachana and religious rites, taught 'Sarvamula' works and organised scholarly meetings during his Paryaya.",
  },
  {
    name: "Sri Vadivandyatirtha",
    period: "Entombed 1706 A.D. - 18 years on the peetha (Paryaya 1692-93)",
    role: "Peethadhipati",
    note:
      "Distinguished scholar who frequently taught Nyayasudha and other major Vedantic works. Organised scholarly discourses and debates during Paryaya periods at Udupi and defeated Shamashastry, a Shaivadvaita scholar, in a debate on Mithyatva. Authored Sri Vadirajastuti, Sri Vadirajashtaka, Jayastotra and Vadirajadhyanaprakara.",
  },
  {
    name: "Sri Vishwavandyatirtha - II (Udupi)",
    period: "Vrindavana-pravesha 1722 A.D. at Udupi - 16 years on the peetha (Paryaya 1708-09)",
    role: "Peethadhipati",
    note:
      "Gained strong command over Sarvamula works and those of Vadiraja. Regularly performed Patha-Pravachana-Parayana of Yuktimallika at Vadiraja's Vrindavana sannidhi. Commanded Poorvamimamsa and Vyakarana; a North Indian scholar was stunned by his mastery. Authored the rare Mimamsa work 'Bhattabodhini'.",
  },
  {
    name: "Sri Vibudhavaryatirtha",
    period: "Vrindavana-pravesha 1739 A.D. - 17 years on the peetha (Paryaya 1724-25)",
    role: "Peethadhipati",
    note:
      "Disciple of Vishwavandyatirtha and a great saint-scholar. Taught Shastric works like Nyayasudha and Yuktimallika. Composed the Mahakavya 'Subhadraharana' after being consoled by Vadiraja in a dream during his unjust detention by the king of Ikkeri, and authored a Shloka-form commentary and gloss on Vishnusahasranama. Renovated the Vadiraja Matha at Sode and taught Srimanyayasudha eleven times.",
  },
  {
    name: "Sri Vishwanidhitirtha",
    period: "Vrindavana-pravesha 1753 A.D. at Undaru - 14 years on the peetha (Paryaya 1740-41)",
    role: "Peethadhipati",
    note:
      "Direct disciple of Vibudhavaryatirtha. Toured extensively in Southern India propagating Dvaita Siddhanta. Had command of Bhagavata and Nyayasudha, reciting and teaching them without texts. Defeated a Shrivaishnava scholar in a debate on Bhakti.",
  },
  {
    name: "Sri Vishwadhishwaratirtha",
    period: "Entombed 1803 A.D. at Undaru - 50 years on the peetha",
    role: "Paramaguru of Sri Vrindavanacharya",
    note:
      "Known as 'Senior Swamiji'. Dedicated his life to worship, Paryaya, teaching and discourse. Performed two biennial Paryayas gloriously and memorised Bhagavata, Nyayasudha and Yuktimallika. Adorned in Vrindavanakhyana as 'Vipraparamaguru'. Received and gifted a golden Mantapa to Sri Krishnamatha, Udupi.",
  },
  {
    name: "Sri Vishweshatirtha",
    period: "19th century",
    role: "Peethadhipati",
    note:
      "Preserved and patronised traditional Sanskrit scholarship. Guided the tradition faithfully through the late-19th-century period, upholding the Sarvamula tradition and the sacred observances at Sode and its branch mathas.",
  },
  {
    name: "Sri Vishwapriyatirtha (Srimadvrindavan Acharya)",
    period: "1774 - 1865 (91 years) - 62 years on the peetha (Paryayas 1804-05, 1820-21, 1836-37, 1852-53)",
    role: "Srimadvrindavan Acharya",
    note:
      "Shakapurusha and mystic divine being of the 19th century. Ordained Samnyasashrama at age ten by Sri Vishwesha-tirtha. Studied under Sri Vishwadhishwaratirtha and, guided by Vadiraja in a dream, went to Sode. Engaged in devoted service at Sri Vadiraja's Panchavrindavanasannidhi where - through Vadiraja's divine speech emanating from the Vrindavana - he became known as Vrindavanacharya. He is the chief listener 'Vipra' in Vrindavanakhyana. His Vairagya was incomparable - wearing only a Kaupin. He saved devotees from drowning, brought forth Ganga at Dhavalatirtha, and sweetened ocean water for Achamana by his word.",
  },
  {
    name: "Sri Vishwadhishatirtha",
    period: "Entombed 1889 A.D. at Udupi - 34 years on the peetha (Paryayas 1868-69, 1884-85)",
    role: "'Hiriya Swamigalu' - Senior Swamiji",
    note:
      "Direct disciple of Vrindavanacharya. Possessed knowledge from past lives. Recited Samgraha Ramayana for one Mandala to please his Guru, becoming an undaunted scholar-debater. Taught Swamijis of other Mathas including Vibudhapriya-tirtha, Vidyasamudratirtha and Vidyapurnatirtha. Published 'Rujutvachandrodaya' at Udupi to defend Vadiraja's Rujutva and renovated parts of Sri Krishnamatha. Queen Victoria recognised his scholarship.",
  },
  {
    name: "Sri Vishwendratirtha",
    period: "1881 - 1943 (Vrindavana-pravesha at Udyavara) - 44 years on the peetha (Paryayas 1900-01, 1916-17, 1932-33)",
    role: "Peethadhipati",
    note:
      "Took Samnyasashrama at 16 and continued higher studies under Sri Vibudhapriyatirtha of Adamar Matha. A great scholar of Veda-Vedanta equally talented in Kannada literature, composing under the pen name 'Rajesh-Rajanath'. Composed the Sanskrit 'Sri Vadirajashtaka'. Renovated the Vrindavanashala at Udupi (completed 02-01-1934). Established 'Vishnumurthy Hayavadanaswamy High School' at Innanje - the first modern school in the region - now a Pre-University College. Organised the 'Yuktimallika Sourabha Prakashini' scholarly meet and toured Cochin (1928) and Mysore (1939) receiving royal honours. In his old age at Udyavara Matha he prepared the celebrated medicated oil 'Hayagrivataila', still made by the Swamijis of Sode Vadiraja Matha, and treated patients successfully. His diamond jubilee of Peetharohana was celebrated in 1941.",
  },
  {
    name: "Sri Vishwottamatirtha",
    period: "1934 - 2007 - 64 years on the peetha (Paryayas 1948-49, 1964-65, 1980-81, 1996-97)",
    role: "Previous Peethadhipati",
    note:
      "Saint-pontiff of the 20th century known for his discipline and deep Shastric knowledge. Ordained in 1943 at age nine, continued higher studies under Sri Vidyasamudratirtha. Deeply devoted to Madhvasiddhanta and Vadiraja's Rujutva. Provided solutions to devotees through blessed Mantrakshata and Hitopadesha and collected over two thousand rare manuscripts. Upgraded the Innanje institution to a PU College and undertook extensive renovation and construction across the Matha's branches, especially at Sode. Performed four grand Paryayas, organised Vadiraja Jayanti, constructed the Vadiraja Mandira, had the entire Vrindavanakhyana stone-inscribed and built the Akhyanamanidra, and established the Bhavisameera Gurukula. Departed the mortal body on 18-08-2007.",
  },
  {
    name: "Sri Vishwavallabhatirtha (The Present Pontiff)",
    period: "Born 24-03-1991 • Samnyasashrama 14-06-2006",
    role: "The Present Peethadhipati",
    note:
      "Chose Samnyasashrama at a young age, ordained by Sri Vishwottamatirtha. Studied under Sri Vidyasagaratirtha and took over the Matha's administration after his Guru's ascension. Undertook extensive renovation and construction work. Established 'Srimadvrindavanacharya Samshodhana hagu Prakashana Kendra' for preserving manuscripts and 'Sri Vishwottamatirtha Masika Vidwatsambhavane' to support scholars. Continues the Bhavisameera Gurukula and inaugurated 'Sri Madhva Vadiraja Institute of Technology and Management' plus the English-medium wing at Innanje. Launched the monthly magazine 'Tattvamallika' and honours scholars annually. Conducts festivals, lectures and daily Japa-Tapa. His first biennial Paryaya was described as unprecedented, with numerous religious and cultural programmes.",
  },
];
